"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var KonsulOptions = exports.KonsulOptions = function () {
  function KonsulOptions(input) {
    return input != null && (input.clear === undefined || typeof input.clear === 'boolean') && (input.renderDebounce === undefined || typeof input.renderDebounce === 'number');
  }

  ;
  Object.defineProperty(KonsulOptions, Symbol.hasInstance, {
    value: function value(input) {
      return KonsulOptions(input);
    }
  });
  return KonsulOptions;
}();


//////////////////
// WEBPACK FOOTER
// ../lib/types/konsul.js
// module id = 688
// module chunks = 0